import React from 'react';

interface RamisConfigurationProps {
    configuration: {
        BaseUrl?: string;
        Token?: string;
        Timeout?: number;
        Warehouses?: string;
    };
    onChange: (field: string, value: string | number) => void;
    disabled?: boolean;
}

interface RamisConfigurationComponent extends React.FC<RamisConfigurationProps> {
    configFields: string[];
}

const RamisConfiguration: RamisConfigurationComponent = ({
    configuration,
    onChange,
    disabled = false
}) => {
    return (
        <React.Fragment>
            <div className="form-group-custom">
                <label className="form-label-custom">
                    <span className="label-icon">🌐</span>
                    Базовый URL
                </label>
                <div className="input-group-custom">
                    <input
                        type="url"
                        className="form-input-custom"
                        value={configuration.BaseUrl || ''}
                        onChange={(e) => onChange('BaseUrl', e.target.value)}
                        placeholder="https://api.ramis.example.com"
                        disabled={disabled}
                    />
                </div>
            </div>

            <div className="form-group-custom">
                <label className="form-label-custom">
                    <span className="label-icon">🔑</span>
                    Токен авторизации
                </label>
                <div className="input-group-custom">
                    <input
                        type="password"
                        className="form-input-custom"
                        value={configuration.Token || ''}
                        onChange={(e) => onChange('Token', e.target.value)}
                        placeholder="Введите токен"
                        disabled={disabled}
                        autoComplete='new-password'
                    />
                </div>
            </div>

            <div className="form-group-custom">
                <label className="form-label-custom">
                    <span className="label-icon">⏱️</span>
                    Таймаут (секунды)
                </label>
                <div className="input-group-custom">
                    <input
                        type="number"
                        className="form-input-custom"
                        value={configuration.Timeout || ''}
                        onChange={(e) => {
                            const value = e.target.value;
                            onChange('Timeout', value ? parseInt(value) : '');
                        }}
                        min="1"
                        placeholder="30"
                        disabled={disabled}
                    />
                </div>
            </div>
        </React.Fragment>
    );
};

// Define the configuration fields used by this supplier
RamisConfiguration.configFields = ['BaseUrl', 'Token', 'Timeout'];

export default RamisConfiguration;
